import { useLoaderData } from '@ubo/losse-sjedel'
import { type PageBodyData } from '~/templates/page'

export default function useGlobalCounters() {
  const { rest } = useLoaderData<PageBodyData>()

  return rest.globalCounters
}
